import { createSlice } from '@reduxjs/toolkit';
import { placeCategorySchema } from 'entities/place-category';
import { placeSchema } from 'entities/place';
import BaseError from '../../../utils/base-error';
import { PlacesPageState } from './state';
import { PlacesPageActions } from './actions';

const initialState: PlacesPageState = {
    loaded: false,
    errors: [],
    places: [],
    categories: [],
};

export const placesPageSlice = createSlice({
    name: 'placesPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            PlacesPageActions.getPlaceCategories.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const { data } = response.data;

                        state.categories = data.map((dto) => (
                            placeCategorySchema.parse(dto)
                        ));
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            PlacesPageActions.getPlacesByCategory.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const { data } = response.data;

                        state.places = data.map((dto) => (
                            placeSchema.parse(dto)
                        ));

                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
